export default {"src":"/_next/static/media/street-view-color.54bb64bf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};